// this regex tests these three conditions:
// 1. starts with "V"
// 2. followed by 11 alphanumeric characters excluding 0, O, I, l (this matches encoding map)
// 3. optionally ends with 4 digits
const regex = /^V{1}[1-9A-HJ-NP-Za-km-z]{11}([0-9]{4})?$/

const isVoucher = (code: string): boolean => {
  return regex.test(code)
}

export default isVoucher
